import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";

export async function UpdateAdvisorFirmMultiUser(user_email, action) {
    const Token = sessionStorage.getItem("Token");

    if (CheckSessionTimeout(Token)) {
        return { status: 401 };
    }

    const header = { Authorization: `Bearer ${Token}` };

    const raw = JSON.stringify({
        session_id: Token,
        user_email: user_email,
        action: action
    });

    const requestOptions = {
        method: "PATCH",
        body: raw,
        redirect: "follow",
        headers: header,
    };

    try {
        const response = await fetchWithTimeout(
            process.env.REACT_APP_ADVISOR_FIRM_MULTIUSER_API,
            requestOptions
        );
        const message = await response.json();

        if (!response.ok) {
            return { status: response.status, error: message.error || message };
        }

        return { status: response.status, result: message.result };
    } catch (error) {
        console.error('UpdateAdvisorFirmMultiUser error:', error);
        return { status: 0, error: error.message };
    }
}
